import Header from '../../components/common/header/index.vue'
import axios from 'axios'
export default {
  name: 'yjztModule',
  components: { Header },
  data () {
    return {
      loading: false,
      // 对应关系
      matchObj: {
        hswh: {
          name: '红色文化研究',
          id: '0051090501'
        },
        yhyl: {
          name: '雨花英烈研究',
          id: '0051090503'
        },
        zhgl: {
          name: '综合管理研究',
          id: '0051090505'
        }
      },
      // 跳转过来的模块code
      moduleCode: '',
      // 跳转过来的模块名字
      moduleName: '',
      moduleid: '',
      naviList: [],
      naviSelect: '',
      pageNo: 1,
      pageSize: 15,
      total: 0,
      tableData: []
    }
  },
  // 创建元素
  mounted () {
    this.moduleCode = this.$route.query.module
    this.moduleName = this.matchObj[this.moduleCode].name
    this.moduleid = this.matchObj[this.moduleCode].id
    if (this.moduleid === '0051090503') {
      this.naviSelect = this.moduleid
      this.getSpecialData()
    } else {
      this.getAllZTType()
    }
  },
  // 方法定义
  methods: {
    getAllZTType () {
      const self = this
      axios.get('/yuhuamenhu/special/getAllZTType').then(json => {
        if (json.status === 200) {
          let naviList = []
          json.data.forEach(item => {
            if (item.id === self.moduleid) {
              naviList = item.children
            }
          })
          naviList.forEach(item => {
            if (item.children !== undefined) {
              item.open = false
            }
          })
          self.naviList = naviList
          if (self.naviList[0].children !== undefined) {
            self.naviList[0].open = true
          }
          // 第一个选中id
          self.naviSelect = self.naviList[0].children !== undefined ? self.naviList[0].children[0].id : self.naviList[0].id
          self.getSpecialData()
        }
      }).catch(err => {
        console.log(err)
      })
    },

    // 点击一级导航
    clickNavi (item) {
      if (item.children === undefined) {
        this.naviSelect = item.id
        this.pageNo = 1
        this.getSpecialData()
      } else {
        item.open = !item.open
      }
    },

    // 点击
    clickNaviC (itemC) {
      this.naviSelect = itemC.id
      this.pageNo = 1
      this.getSpecialData()
    },

    // 点击分页
    changePage (val) {
      this.pageNo = val
      this.getSpecialData()
    },

    // 获取表格数据
    getSpecialData () {
      const self = this
      self.loading = true
      const data = {
        pageNo: self.pageNo,
        pageSize: self.pageSize,
        ywfldm: self.naviSelect
      }
      axios.post('/yuhuamenhu/special/getSpecialData', data).then(json => {
        if (json.status === 200) {
          self.total = json.data.data.totalRows
          self.tableData = json.data.data.rows
        } else {
          self.$message.warning(json.data.errorMessage)
        }
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        self.loading = false
      })
    },

    // 跳转到详情页面
    enterDetail (param) {
      const yjztDetail = this.$router.resolve({
        path: '/yjztDetail',
        query: {
          name: param.name,
          from: param.from
        }
      })
      window.open(yjztDetail.href, '_blank')
    },

    // 返回首页
    goHome () {
      this.$router.push('/')
    },

    // 返回专题研究
    goZtyj () {
      this.$router.push('/yjzt')
    }
  }
}
